export default __webpack_public_path__ + "static/media/select.b4009597.svg";